/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { createEmbeddingContext } from "amazon-quicksight-embedding-sdk";
import "./other.css";
// import { Link } from "react-router-dom";
// import { IoIosLogOut } from "react-icons/io";
// import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../components/feedBacks/loader";
// import { useAppSelector } from "../../../store/hooks";
// import { selectAuthSlice } from "../../../store/authSlice";
import { usePostData } from "../../../customHooks/usePostData";
// import { IconWrapper } from "../../../customHooks/useIcon";

// Define an interface for the payload
interface QuickSightPayload {
  accountId: string;
  dashboardId: string;
  namespace: string;
  authorizedResourceArns: string[];
  allowedDomains: string[];
  sessionTags: any[];
}

// Define an interface for the response
interface QuickSightResponse {
  EmbedUrl: string;
  [key: string]: any;
}

const DashboardEmbedUrl = () => {
  //   const userInfo = useAppSelector(selectAuthSlice).user;
  //   const role = userInfo?.access_level;
  const containerRef = useRef<HTMLDivElement>(null);
  const [embedUrl, setEmbedUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  //   const { logout } = useAuth0();

  const dashboardId = "4890f1f2-24a3-4825-a14d-0dde66834796";
  const accountId = "368563411071";
  const namespace = "default";
  const { mutate } = usePostData<QuickSightResponse, QuickSightPayload>(
    "/generate-embed-url",
    "POST",
    {
      onSuccess: (data) => {
        setEmbedUrl(data.EmbedUrl);
        setIsLoading(false);
      },
      onError: (error) => {
        setError(
          "Error while fetching your dashboard. Please try again later."
        );
        setIsLoading(false);
        localStorage.removeItem("auth0Token");
        window.location.href = "/auth/login";
        console.error("Error fetching embed URL:", error);
      },
    }
  );

  //   const handleLogout = () => {
  //     localStorage.removeItem("auth0Token");
  //     logout({ returnTo: `${window.location.origin}/login` });
  //   };

  useEffect(() => {
    if (!embedUrl) return;

    const embedQuickSight = async () => {
      try {
        const embeddingContext = await createEmbeddingContext();
        const { embedDashboard } = embeddingContext;

        embedDashboard({
          url: embedUrl,
          container: containerRef.current!,
          width: "100%",
          height: "100%", 
          className: "quicksight-embedding-iframe",
        });
      } catch (error) {
        console.error("Error embedding QuickSight:", error);
      }
    };

    embedQuickSight();
  }, [embedUrl]);
  const embedDashboard = useCallback(() => {
    const payload: QuickSightPayload = {
      accountId,
      dashboardId,
      namespace,
      authorizedResourceArns: [
        `arn:aws:quicksight:eu-west-2:${accountId}:dashboard/${dashboardId}`,
      ],
      allowedDomains: [
        "http://localhost:3003",
        "https://demo.powersmarter.net",
        "https://dev.demo.powersmarter.net/",
      ],
      sessionTags: [],
    };

    mutate(payload);
  }, [mutate, dashboardId, accountId]);
  // Call embedDashboard in useEffect
  useEffect(() => {
    embedDashboard();
  }, [embedDashboard]);
    
  return (
    <div className="flex justify-center items-center w-full h-full">
      {isLoading ? (
        <Loader />
      ) : error?.trim() ? (
        <p className="text-red-600 text-2xl">{error}</p>
      ) : (
        <div
          ref={containerRef}
          className="relative p-6 w-full h-[80vh] rounded-2xl border border-gray-200 bg-[#F7F7F7] overflow-y-hidden"
        >
          {/* hide powered by */}
          <div className="absolute bottom-5 right-0 h-[20px] w-[200px] bg-[#F7F7F7] z-50"></div>
        </div>
      )}
    </div>
  );
};

export default DashboardEmbedUrl;
